const UrlQueryPageLoad = {
	init({ el }) {
		const query = el?.dataset?.url;
		if (query) window.history.replaceState(null, null, `?${query}`);
	},
};

export { UrlQueryPageLoad as default };
